/* eslint-disable */
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { magentoUrl } from "@helpers/getDashboardRedirectUrl";
import { useState } from "react";
import { useSelector } from "react-redux";
import { I18n, Translate } from "react-redux-i18n";
import { IState } from "@customTypes/ItemTypes";
import "./NotificationBar.scss";

export function NotificationBar({element}:any): JSX.Element {
  const [show, setShow] = useState(true);
  const profileDetails = useSelector((state: IState) => state.profileDetails);


  const language_preference_code =
    profileDetails.languagePreference ||
    window.localStorage.getItem("language") ||
    "";

  return (
    <div className="notificationStyles">
      <FontAwesomeIcon icon={faCheckCircle} className="notificationStyles_infoIcon" />

      <span className="notificationStyles_message">
      &nbsp;<Translate value={element.description} /> &nbsp;
        <a href={`${magentoUrl(language_preference_code)}`}>
          {I18n.t(element.linkText)}
        </a>
      </span>
      <span onClick={() => setShow(true)} className="notificationStyles_close" />
    </div>
  );
}
